import { ISurvey, ISurveyComponent, ISurveyInfo, SurveyComponentType, SurveyType } from "@ms-ofb/floodgate-shared-typings";
import * as Utils from "../Utils";
import { Survey } from "./Survey";
import SurveyDataSource from "./SurveyDataSource";

const { isNOU } = Utils;

// Dialog survey for dialogs (eg: FRE). Dialog properties have to be added to the SurveyMetadata.
class DialogSurvey extends Survey {
	public static make(data: DialogSurvey.DialogSurveyData): ISurvey {
		try {
			return new DialogSurvey(data);
		} catch (e) {
			return null;
		}
	}

	public static makeCustom(baseData: SurveyDataSource.SurveyDataSourceData): ISurvey {
		if (isNOU(baseData)) {
			return null;
		}

		const data = new DialogSurvey.DialogSurveyData();
		data.baseData = baseData;

		return this.make(data);
	}

	private surveyInfo: SurveyDataSource;

	private constructor(data: DialogSurvey.DialogSurveyData) {
		super();
		if (!data) {
			throw new Error("data must not be null");
		}

		this.surveyInfo = new SurveyDataSource(data.baseData);

		// This check cannot be done in survey info constructor
		// as metadata is specific to this survey type.
		if (isNOU(this.surveyInfo.getMetadata())) {
			throw new Error("metadata must not be null");
		}
	}

	// @Override
	public getType(): SurveyType {
		return SurveyType.Dialog;
	}

	// @Override
	public getSurveyInfo(): ISurveyInfo {
		return this.surveyInfo;
	}

	// @Override
	public getTags(): string[] {
		return this.surveyInfo.getTags();
	}

	// @Override
	public getComponent(_componentType: SurveyComponentType): ISurveyComponent {
		return null;
	}

	// @Override
	public getDomElements(_doc: Document): Element[] {
		return [];
	}

	// @Override
	public getJsonElements(): object {
		return {};
	}
}

module DialogSurvey {
	/**
	 * Data required for a Generic Surface Survey
	 */
	export class DialogSurveyData {
		public baseData: SurveyDataSource.SurveyDataSourceData;
	}
}

export default DialogSurvey;
